import useNotificationBaseActions from './useNotificationBaseActions'

export default useNotificationBaseActions
